import type { SVGProps } from "react";
const SenecPictogramCapitalMarket = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M42.4903 7.87157L34.0782 12.6034L25.2173 9.15743L19.1684 14.7022L12.1378 11.1869L6.64023 15.7682L5.35986 14.2318L11.8623 8.81308L18.8317 12.2978L24.7828 6.84256L33.9219 10.3966L41.5098 6.12842L42.4903 7.87157Z"
            fill="currentColor"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M35 15H42V42H35V15ZM37 17V40H40V17H37Z" fill="currentColor" />
        <path
            d="M6.00005 18H13V42H6.00005V38C6.00005 37.4477 6.44776 37 7.00005 37C7.55233 37 8.00005 37.4477 8.00005 38V40H11V20H8.00005V33C8.00005 33.5523 7.55233 34 7.00005 34C6.44776 34 6.00005 33.5523 6.00005 33V18Z"
            fill="currentColor"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M25 18H33V42H25V18ZM27 20V40H31V20H27Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M15 22H23V42H15V22ZM17 24V40H21V24H17Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramCapitalMarket;
